import type {MessageAttachment, Turn} from '@microsoft/agent-host-protocol'

import type {UserMessageImage} from '../../../types/user-message-image'

// AHP enums are const — compare wire literals (isolatedModules).
const ATTACHMENT_EMBEDDED_RESOURCE = 'embeddedResource'

/** True when an attachment is an inline image we can preview (embedded base64 image data). */
export function isPreviewableUserMessageImageAttachment(att: MessageAttachment | undefined): boolean {
  if (!att || att.type !== ATTACHMENT_EMBEDDED_RESOURCE) return false
  const {data, contentType} = att as {data?: unknown; contentType?: unknown}
  if (typeof data !== 'string' || !data) return false
  return att.displayKind === 'image' || (typeof contentType === 'string' && contentType.startsWith('image/'))
}

/** Extract inline image attachments from a turn's user message for preview. */
export function extractUserMessageImages(message: Turn['message'] | undefined): UserMessageImage[] {
  const attachments = message?.attachments
  if (!Array.isArray(attachments)) return []
  const images: UserMessageImage[] = []
  for (const att of attachments) {
    if (!isPreviewableUserMessageImageAttachment(att)) continue
    const {data, contentType} = att as {data?: unknown; contentType?: unknown}
    const mime = typeof contentType === 'string' ? contentType : 'image/png'
    images.push({
      ...(typeof att._meta?.['github.attachmentId'] === 'string' ? {id: att._meta['github.attachmentId']} : {}),
      name: typeof att.label === 'string' ? att.label : 'image',
      src: `data:${mime};base64,${data}`,
    })
  }
  return images
}
